/**
 * "Últimas tallas" entry points (2026-11). Config: #nc-ut-config (snippets/nc-ut-config.liquid).
 *
 * 1. PDP (box inserted right after the buy buttons; product handle from the
 *    config): when the picked shoe
 *    size is sold out ("Avísame" shown), a card "Tu talla 42 sí está en otros
 *    modelos" links to /collections/ultimas-tallas?talla=<size> (the board opens
 *    on that size) and up to 3 products of the board that have exactly that size
 *    in stock are listed. Shown only when the board has at least 2 products in
 *    exactly that size (no size grouping here, so the copy is never wrong).
 * 2. Size tiles ([data-nc-ut-tiles], sections/nc-ut-sizes.liquid and the desktop
 *    CALZADO panel): one tile per size with >= 2 products in stock, linking to
 *    the board on that size. The section hides itself when no size qualifies.
 *    In the mega menu the data is only fetched when the panel is opened.
 *    The collection grid card (snippets/nc-ut-promo-card.liquid) shows the
 *    sizes with the most products (data-max) and loads when scrolled near.
 * 3. Mobile drawer: links to the collection get a short subtitle.
 *
 * Sizes are grouped like assets/my-size.js (keep SIZE_GROUPS in sync): the
 * board's tiles use the same labels, so ?talla=<label> always matches a tile.
 * Nothing is remembered between pages (merchant decision 2026-09).
 * Events (Shopify customer events + Clarity): ut_entry_click {source, size},
 * ut_pdp_shown {size, count}.
 */
(function () {
  'use strict';
  if (window.__ncUt) return;
  window.__ncUt = true;

  var cfgEl = document.getElementById('nc-ut-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};
  var MIN = 2;

  // ---- sizes: same rules as assets/my-size.js ----
  function norm(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/\s*eu$/, '').replace(',', '.')
      .replace(/\s*1\/3/, '.33').replace('⅓', '.33')
      .replace(/\s*2\/3/, '.67').replace('⅔', '.67')
      .replace('½', '.5')
      .replace(/\.3$/, '.33').replace(/\.6$/, '.67')
      .replace(/\.0$/, '');
  }
  function isNum(s) { return /^\d+(\.\d+)?$/.test(norm(s)); }
  var SIZE_GROUPS = {
    '36.5': '36.5', '36.67': '36.5',
    '37': '37.5', '37.33': '37.5', '37.5': '37.5', '37.67': '37.5',
    '38': '38', '38.5': '38.5', '38.67': '38.5',
    '39': '39', '39.33': '39',
    '40.5': '40.5', '40.67': '40.5',
    '41': '41', '41.33': '41', '41.5': '41',
    '42.5': '42.5', '42.67': '42.5',
    '43': '43', '43.33': '43', '43.5': '43',
    '44.5': '44.5', '44.67': '44.5',
    '45.33': '45.5', '45.5': '45.5',
    '46.5': '46.5', '46.67': '46.5',
    '47.33': '47.5', '47.5': '47.5'
  };
  // the label the board shows for a real size ("40⅔" -> "40.5", "42" -> "42")
  function label(s) { return SIZE_GROUPS[norm(s)] || String(s || '').trim(); }

  var plural = (function () {
    var rules = null;
    try { rules = new Intl.PluralRules(C.locale || 'es'); } catch (e) {}
    return function (n) {
      var cat = rules ? rules.select(n) : (n === 1 ? 'one' : 'other');
      return n + ' ' + (T[cat] || T.other || '');
    };
  })();
  function fill(tpl, map) {
    var s = String(tpl || '');
    Object.keys(map).forEach(function (k) { s = s.split('{' + k + '}').join(map[k]); });
    return s;
  }
  function boardUrl(lab) { return C.url + '?talla=' + encodeURIComponent(lab); }

  function send(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  // ---- data: every product of the board with its sizes ----
  var dataP = null;
  function load() {
    if (dataP) return dataP;
    function page(n) {
      var u = C.url + '?view=size-recs' + (n > 1 ? '&page=' + n : '');
      return fetch(u, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t.trim()); });
    }
    dataP = page(1).then(function (first) {
      var pages = Math.min(parseInt(first.pages, 10) || 1, 4);
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var all = [];
        [first].concat(more).forEach(function (d) { all = all.concat(d.products || []); });
        return all;
      });
    }).catch(function () { dataP = null; return []; });
    return dataP;
  }
  // product has exactly this size in stock (40⅔ = 40 2/3, but 41 ≠ 41.5) → its variant [size, id, available]
  function inSize(p, size) {
    var want = norm(size), z = p.z || [];
    for (var i = 0; i < z.length; i++) {
      if (z[i][2] && norm(z[i][0]) === want) return z[i];
    }
    return null;
  }
  function counts(products) {
    var c = {};
    products.forEach(function (p) {
      var seen = {};
      (p.z || []).forEach(function (v) { if (v[2] && isNum(v[0])) seen[label(v[0])] = true; });
      Object.keys(seen).forEach(function (k) { c[k] = (c[k] || 0) + 1; });
    });
    return c;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }

  // ---- 2. size tiles ----
  function renderTiles(box, products) {
    if (box.dataset.ncUtDone) return;
    box.dataset.ncUtDone = '1';
    var c = counts(products);
    var labels = Object.keys(c).filter(function (k) { return c[k] >= MIN; });
    // data-max: keep the sizes with the most products (e.g. the grid card)
    var max = parseInt(box.dataset.max, 10);
    if (max > 0 && labels.length > max) {
      labels = labels.sort(function (a, b) { return c[b] - c[a]; }).slice(0, max);
    }
    labels.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    var wrap = box.closest('[data-nc-ut-section]') || box;
    if (!labels.length) { wrap.hidden = true; return; }
    var kind = box.dataset.kind || 'tile';
    var src = box.dataset.src || 'tiles';
    box.innerHTML = '';
    labels.forEach(function (lab) {
      var a = el('a', kind === 'pill' ? 'nc-ut-pill' : 'nc-ut-tile');
      a.href = boardUrl(lab);
      a.setAttribute('data-nc-ut-src', src);
      a.setAttribute('data-nc-ut-size', lab);
      if (kind === 'pill') {
        a.textContent = lab;
      } else {
        a.setAttribute('aria-label', lab + ', ' + plural(c[lab]));
        var s = el('span', 'nc-ut-tile__size', lab);
        var n = el('span', 'nc-ut-tile__count', plural(c[lab]));
        s.setAttribute('aria-hidden', 'true');
        n.setAttribute('aria-hidden', 'true');
        a.appendChild(s);
        a.appendChild(n);
      }
      box.appendChild(a);
    });
    wrap.hidden = false;
  }
  function initTiles() {
    document.querySelectorAll('[data-nc-ut-tiles]').forEach(function (box) {
      var go0 = function () { load().then(function (p) { renderTiles(box, p); }); };
      // grid card: fetch only when it comes near the screen
      if (box.hasAttribute('data-nc-ut-lazy') && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go0(); }
        }, { rootMargin: '300px' });
        io.observe(box);
        return;
      }
      var lazy = box.closest('details');
      if (!lazy) { go0(); return; }
      // mega menu: fetch only when the panel is opened / hovered
      var go = function () { load().then(function (p) { renderTiles(box, p); }); };
      lazy.addEventListener('toggle', function () { if (lazy.open) go(); });
      var li = lazy.closest('li') || lazy;
      li.addEventListener('mouseenter', go, { once: true });
      li.addEventListener('focusin', go, { once: true });
    });
  }

  // ---- 3. mobile drawer subtitle ----
  function initDrawer() {
    if (!T.pick) return;
    var path = C.url.replace(/^https?:\/\/[^/]+/, '');
    document.querySelectorAll('.menu-drawer a[href], #menu-drawer a[href], .header__menu-drawer a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.split('?')[0] !== path || a.classList.contains('nc-ut-drawer-link')) return;
      a.classList.add('nc-ut-drawer-link');
      a.setAttribute('data-nc-ut-src', 'drawer');
      a.appendChild(el('span', 'nc-ut-drawer-link__sub', T.pick));
    });
  }

  // ---- 1. PDP ----
  function visible(e) {
    return !!(e && e.offsetParent !== null && !e.hidden && !e.classList.contains('hidden'));
  }
  function initPdp() {
    if (!C.product) return;
    var info = document.querySelector('.pdp-v2 .product__info-container') || document.querySelector('.product__info-container');
    if (!info) return;
    var picker = info.querySelector('variant-radios, variant-selects');
    var form = info.querySelector('product-form, .product-form');
    if (!picker || !form) return;
    // the block that holds the buy buttons (direct child of the info column)
    var anchor = form;
    while (anchor.parentElement && anchor.parentElement !== info) anchor = anchor.parentElement;
    var box = el('div', 'nc-ut-pdp');
    box.hidden = true;
    box.setAttribute('data-nc-ut-pdp', '');
    if (anchor.parentElement === info) anchor.insertAdjacentElement('afterend', box);
    else form.insertAdjacentElement('afterend', box);
    var handle = C.product;
    var seq = 0;
    var shownFor = '';

    // the picked shoe size (skips other options such as colour)
    function pickedSize() {
      var r = picker.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < r.length; i++) if (isNum(r[i].value)) return r[i].value;
      var s = picker.querySelectorAll('select');
      for (var j = 0; j < s.length; j++) if (isNum(s[j].value)) return s[j].value;
      return '';
    }
    function soldOut() {
      var n = info.querySelectorAll('.product-form__notify');
      for (var i = 0; i < n.length; i++) if (visible(n[i])) return true;
      return false;
    }
    function hide() { box.hidden = true; box.innerHTML = ''; shownFor = ''; }

    function render(size, lab, hits) {
      box.innerHTML = '';
      var card = el('a', 'nc-ut-pdp__card');
      card.href = boardUrl(lab);
      card.setAttribute('data-nc-ut-src', 'pdp');
      card.setAttribute('data-nc-ut-size', lab);
      var txt = el('span', 'nc-ut-pdp__txt');
      txt.appendChild(el('span', 'nc-ut-pdp__title', fill(T.pdpTitle, { size: size })));
      txt.appendChild(el('span', 'nc-ut-pdp__sub', plural(hits.length) + ' ' + (T['in'] || '') + ' · ' + (C.title || '')));
      card.appendChild(txt);
      var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      arrow.setAttribute('viewBox', '0 0 24 24');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.setAttribute('class', 'nc-ut-pdp__arrow');
      arrow.innerHTML = '<path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2"></path>';
      card.appendChild(arrow);
      box.appendChild(card);

      var top = hits.slice().sort(function (a, b) { return (Number(b.p.s) || 0) - (Number(a.p.s) || 0); }).slice(0, 3);
      box.appendChild(el('p', 'nc-ut-pdp__h', fill(T.alts, { size: size })));
      var list = el('ul', 'nc-ut-pdp__alts');
      top.forEach(function (h) {
        var p = h.p, v = h.v;
        var li = el('li', 'nc-ut-pdp__alt');
        var a = el('a', 'nc-ut-pdp__alt-link');
        a.href = p.u + (p.u.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v[1] + '&pick=1';
        a.setAttribute('data-nc-ut-src', 'pdp_product');
        a.setAttribute('data-nc-ut-size', lab);
        var m = el('span', 'nc-ut-pdp__media');
        if (p.i) {
          var img = el('img');
          img.src = p.i; img.alt = ''; img.loading = 'lazy'; img.width = 400; img.height = 400;
          m.appendChild(img);
        }
        a.appendChild(m);
        a.appendChild(el('span', 'nc-ut-pdp__name', p.t));
        var pr = el('span', 'nc-ut-pdp__price' + (p.cf ? ' nc-ut-pdp__price--sale' : ''));
        pr.appendChild(el('span', 'nc-ut-pdp__now', p.pf));
        if (p.cf) pr.appendChild(el('s', 'nc-ut-pdp__was', p.cf));
        a.appendChild(pr);
        li.appendChild(a);
        list.appendChild(li);
      });
      box.appendChild(list);
      box.hidden = false;
    }

    function check() {
      var size = pickedSize();
      if (!size || !isNum(size) || !soldOut()) { hide(); return; }
      if (shownFor === size && !box.hidden) return;
      var lab = label(size);
      var my = ++seq;
      load().then(function (products) {
        if (my !== seq) return;
        if (pickedSize() !== size || !soldOut()) return;
        var hits = [];
        products.forEach(function (p) {
          if (p.h === handle) return;
          var v = inSize(p, size);
          if (v) hits.push({ p: p, v: v });
        });
        if (hits.length < MIN) { hide(); return; }
        render(size, lab, hits);
        shownFor = size;
        send('ut_pdp_shown', { size: lab, count: hits.length });
      });
    }
    picker.addEventListener('change', function () {
      // the theme swaps the buttons after its own change handler
      setTimeout(check, 80);
      setTimeout(check, 450);
    });
    setTimeout(check, 300);
    window.addEventListener('pageshow', function (e) { if (e.persisted) setTimeout(check, 100); });
  }

  // ---- click log ----
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nc-ut-src]');
    if (!a) return;
    send('ut_entry_click', { source: a.getAttribute('data-nc-ut-src'), size: a.getAttribute('data-nc-ut-size') || '' });
  });

  function init() {
    initPdp();
    initTiles();
    initDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
